import React from 'react';
import HeaderTitle from '../../../../components/typography/header-title';
import KafkaTagging from '../../../../components/table/kafkaTaggingTable';

const KafkaMetaData = () => {
    return (
        <>
            <HeaderTitle
                title={'Kafka Topics Tagging'}
                subtitle={'Manage metadata for Kafka Topics.'}
            />
            <KafkaTagging />
        </>
    );
};

export default KafkaMetaData;
